module.exports = __webpack_public_path__ + "img/whatsapp.a192af57.png";